export default __webpack_public_path__ + "static/media/crop-gif-lovies.edafa93e.gif";